import { useTranslation } from 'libs/i18n'
import { HistoryTable } from 'shared/components'
import { Header } from 'shared/components'
import { useFetchAreaHistory } from './queries/useFetchAreaHistory'

const AreaHistory = () => {
	const { t } = useTranslation()
	const { boothHistory, isAreaHistoryLoading } = useFetchAreaHistory()

	return (
		<>
			<Header title={t('Area / History')} />
			<HistoryTable results={boothHistory?.data} isLoading={isAreaHistoryLoading} />
		</>
	)
}

export default AreaHistory
